import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';
import { ToastrService } from 'ngx-toastr';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { LeadActivityService } from 'src/app/private/services/lead-activity.service';
import { buildCommunicationLogPayload, CommunicationLogPayload, extractCommunicationLogId } from 'src/app/utils/communication-log.util';
import { of, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
declare var RingoverSDK: any;

@Component({
  selector: 'app-ringover-call',
  templateUrl: './ringover-call.component.html',
  styleUrls: ['./ringover-call.component.scss']
})
export class RingoverCallComponent {

  @Input() communicationData: any;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() communicationLogged = new EventEmitter<void>();

  @ViewChild('Content1') content1: any;

  btnLoading: boolean = false;
  isDropdownOpen: boolean = false;

  constructor(
    private toast: ToastrService,
    private api: LeadService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private localStorage: LocalStorageService,
    private leadActivity: LeadActivityService
  ){

  }

  
  phoneForm!: FormGroup;
  phoneNumberUtil = PhoneNumberUtil.getInstance();
  timeWhenCallStarted: any;
  timeWhenCallEnded: any;
  hangUpCallData: any;

  simpleSDK: any;
  notes: string = ''; 
  isDialerReady: boolean = false;
  btnLoading3: boolean = false;
  private communicationLogId: number | null = null;


  ngOnInit(): void {

    this.simpleSDK = new RingoverSDK();
    this.simpleSDK.on('changePage', this.logEvent);
    this.simpleSDK.on('ringingCall', this.logEvent);
    this.simpleSDK.on('answeredCall', this.logEvent);
    this.simpleSDK.on('hangupCall', this.logEvent);
    this.simpleSDK.on('login', this.logEvent);
    this.simpleSDK.on('logout', this.logEvent);
    this.simpleSDK.on('dialerReady', this.logEvent);
    this.simpleSDK.on('smsSent', this.logEvent);
    this.simpleSDK.on('smsReceived', this.logEvent);
    this.simpleSDK.on('callLogOpened', this.logEvent);

    this.phoneForm = this.fb.group({
      phone: ['', [Validators.required]]
    });
    
    // Set default phone value if available
    if (this.communicationData?.contact_phone) {
    console.log('Communication Data:', this.communicationData);

    if(this.communicationData.country_code === null || this.communicationData.country_code === undefined){
      this.setPhoneValue(this.communicationData.contact_phone);
    }else{
      this.setPhoneValue('+' + this.communicationData.country_code + this.communicationData.contact_phone);
    }
    }
  }

  // Helper function to set phone value dynamically
  private setPhoneValue(phone: string): void {
    try {
      const parsedNumber = this.phoneNumberUtil.parseAndKeepRawInput(phone);
      const internationalNumber = this.phoneNumberUtil.format(parsedNumber, PhoneNumberFormat.INTERNATIONAL);
      console.log('Parsed phone number:', parsedNumber);
      console.log("internationalNumber", internationalNumber);
      this.phoneForm.get('phone')?.setValue(internationalNumber);
    } catch (error) {
      console.warn('Invalid phone number format:', error);
      this.phoneForm.get('phone')?.setValue(phone); // Set raw value if parsing fails
    }
  }

  // Custom validator to ensure phone number matches country code
  isPhoneNumberValid(phoneNumber: any): boolean {
    // this.phone_number = phoneNumber.internationalNumber;
    // console.log("phone_number",this.phone_number)
    try {
      const parsedNumber = this.phoneNumberUtil.parseAndKeepRawInput(
        phoneNumber.number,
        phoneNumber.countryCode
      );
      return this.phoneNumberUtil.isValidNumber(parsedNumber);
    } catch (error) {
      console.error('Error validating phone number:', error);
      return false;
    }
  }

  // Close the modal
   closeModal() {
    this.destroy();
    this.modalService.dismissAll();
    // this.close.emit();
  }

  // Handle Proceed button click
  onProceed(): void {
    if (this.phoneForm.valid) {
      const phoneNumber = this.phoneForm.get('phone')?.value;

      if (this.isPhoneNumberValid(phoneNumber)) {
        console.log('Phone number is valid:', phoneNumber);
        this.generate();
        this.dial(phoneNumber);
        
      } else {
        console.error('Invalid phone number');
      }
    }
  }

  generate() { this.simpleSDK.generate(); }
  dial(number:any) { this.simpleSDK.dial(number?.e164Number); }
  logEvent = (e: any) => {
    console.log("Action",e?.action);
    console.log("Data",e?.data);

    if(e?.action === "dialerReady"){
      this.isDialerReady = true;
    }

    if(e?.action === "ringingCall"){
      this.timeWhenCallStarted = new Date();
    }

    if(e?.action === "hangupCall"){
      this.timeWhenCallEnded = new Date();
      console.log("Call Duration",this.timeWhenCallEnded - this.timeWhenCallStarted);

      this.hangUpCallData = e?.data;

      this.destroy();
      this.persistCallCommunicationLog('').subscribe({
        next: () => {
          this.communicationLogged.emit();
          this.openCallRemarkModal();
        },
        error: () => this.openCallRemarkModal(),
      });
    }

    // const p = document.createElement('pre');
    // p.innerText = `${e.action} => ${JSON.stringify(e.data)}`;
    // document.getElementById('get-events')?.appendChild(p);
  };

  destroy() { this.simpleSDK.destroy(); }

  private openCallRemarkModal(): void {
    this.modalService.open(this.content1, {
      size: 'lg',
      scrollable: true,
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }

  private buildCallLogPayload(note: string): CommunicationLogPayload {
    const startedAt = this.timeWhenCallStarted || new Date();
    return buildCommunicationLogPayload(this.localStorage, {
      lead_id: this.communicationData?.lead_id,
      communication_type: 'call',
      note,
      date_of_communication: startedAt.toISOString().split('T')[0],
      time_of_communication: startedAt.toTimeString().split(' ')[0],
      call_extra_details: this.hangUpCallData,
      status:
        this.hangUpCallData?.channel_id !== null ? 'Connected' : 'Disconnected',
    });
  }

  private persistCallCommunicationLog(note: string): Observable<any> {
    const leadId = this.communicationData?.lead_id;
    if (!leadId) {
      return of(null);
    }

    const payload = this.buildCallLogPayload(note);
    return this.api.CreateCommunicationHisLog(payload).pipe(
      tap((res: unknown) => {
        const logId = extractCommunicationLogId(res);
        if (logId) {
          this.communicationLogId = logId;
          this.leadActivity
            .recordCommunication(
              leadId,
              logId,
              'call',
              note,
              payload.status
            )
            .subscribe();
        }
      })
    );
  }

  saveNotes() {
      try{
        this.btnLoading3 = true;
        const leadId = this.communicationData?.lead_id;
        if (!leadId) {
          this.toast.error('Lead not found');
          this.btnLoading3 = false;
          return;
        }

        const finish = () => {
          this.communicationLogged.emit();
          this.modalService.dismissAll();
          this.btnLoading3 = false;
        };

        if (this.communicationLogId) {
          this.api
            .UpdateCommunicationHisLog({
              id: this.communicationLogId,
              note: this.notes,
            })
            .subscribe({
              next: () => {
                this.toast.success('Remark saved successfully');
                this.communicationLogged.emit();
                finish();
              },
              error: () => {
                this.toast.error('Error saving remark');
                this.btnLoading3 = false;
              },
            });
          return;
        }

        const payload = this.buildCallLogPayload(this.notes);
      this.api.CreateCommunicationHisLog(payload).subscribe({
        next: (res: any) => {
          this.toast.success('Notes saved successfully');
          const logId = extractCommunicationLogId(res);
          if (logId) {
            this.communicationLogId = logId;
            this.leadActivity
              .recordCommunication(
                leadId,
                logId,
                'call',
                this.notes,
                payload.status
              )
              .subscribe({ next: finish, error: finish });
          } else {
            finish();
          }
        },
        error: () => {
          this.toast.error('Error saving communication history');
          this.btnLoading3 = false;
        }
      });
      }catch(e){
        this.btnLoading3 = false;
        this.toast.error('Error saving notes');
        console.error(e);
      }
  }
  

}
